<app-organizer-shared-form-wrapper
  class="organizer-activity-creation-page-group-size"
  [activeStep]="2"
  [error$]="error$"
  [formGroup]="formGroup"
  [sectionDescription]="
    'activity_creation.group_size.section.description' | translate
  "
  [sectionTitle]="'activity_creation.group_size.section.title' | translate"
  (formSubmit)="submit($event)"
>
  <app-form-control
    [label]="'activity_creation.group_size.group_size.label' | translate"
    [errorMessages]="errorMessages('groupSize')"
  >
    <app-form-input
      formControlName="groupSize"
      [min]="minimumGroupSize"
      [placeholder]="
        'activity_creation.group_size.group_size.placeholder' | translate
      "
      [type]="inputType"
    ></app-form-input>
  </app-form-control>
</app-organizer-shared-form-wrapper>
